module.exports = __webpack_public_path__ + "img/man.fc7952de.png";